import script from "./Topics.vue?vue&type=script&setup=true&lang=js"
export * from "./Topics.vue?vue&type=script&setup=true&lang=js"

import "./Topics.vue?vue&type=style&index=0&id=52db5417&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52db5417"]])

export default __exports__